import { getTmsInstance } from "integration-web-core--socle/js/assets/commons/_tms";
import Carousel from './sponsoredBrandsCarousel';
const pushTmsFragment = getTmsInstance().prepareFragment();
lm.DOMReady(() => {
  let currentCarousel;
  const tmsDataElement = document.getElementById('arm-brands-sponsored-carousel-tms-data');
  const tmsFragment = tmsDataElement ? JSON.parse(tmsDataElement.textContent) : [];
  pushTmsFragment(tmsFragment);
  const initializeCarousel = () => {
    const carouselElement = document.getElementById('arm-brands-sponsored-carousel');
    const carouselIsConnected = carouselElement?.isConnected;
    const carouselContent = carouselElement?.querySelector('.js-carousel-content');
    const contentIsConnected = carouselContent?.isConnected;
    if (!carouselIsConnected || !contentIsConnected) {
      currentCarousel?.destroy();
      currentCarousel = undefined;
      if (carouselIsConnected) {
        scheduleInitialization();
      }
      return;
    }
    const currentCarouselIsConnected = currentCarousel?.carousel?.isConnected && currentCarousel?.content?.isConnected;
    if (currentCarouselIsConnected && currentCarousel.carousel === carouselElement) {
      currentCarousel.refreshLayout();
      return;
    }
    currentCarousel?.destroy();
    currentCarousel = new Carousel(carouselElement);
    carouselContent.addEventListener('scroll', () => {
      const scrollLeft = carouselContent.scrollLeft;
      const atEnd = scrollLeft + carouselContent.clientWidth >= carouselContent.scrollWidth - 1;
      carouselElement.classList.toggle('mc-carousel--scrolled', scrollLeft > 0);
      carouselElement.classList.toggle('mc-carousel--scroll-end', atEnd);
    });
    const buttonsModal = document.querySelectorAll('.arm-brands-sponsored-open-modal');
    buttonsModal.forEach(button => button.addEventListener('click', () => {
      const io = button.getAttribute('data-io');
      document.dispatchEvent(new CustomEvent('arm-popin-dsa-open', {
        detail: io
      }));
    }));
  };
  let scheduledInitialization;
  const scheduleInitialization = () => {
    if (scheduledInitialization) {
      cancelAnimationFrame(scheduledInitialization);
    }
    scheduledInitialization = requestAnimationFrame(() => {
      scheduledInitialization = undefined;
      initializeCarousel();
    });
  };
  initializeCarousel();
  window.addEventListener('guidance:dom:updated', scheduleInitialization);
});